module.exports = "<button ng-if=\"!$ctrl.link\" type=\"button\" ng-click=\"$ctrl.openHelpWindow()\" class=\"btn btn-default help-button\">\n    <span class=\"easyblank-icon\">H</span>\n\n    <span ng-if=\"$ctrl.label\" class=\"button-label-container\">\n      <span class=\"button-label\">Help</span>\n    </span>\n</button>\n<a ng-click=\"$ctrl.openHelpWindow()\" ng-if=\"$ctrl.link\">{{ $ctrl.link }} </a>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/info-widget/info-widget.html
// module id = 447
// module chunks = 0